import MapFieldState from '../interfaces/states/MapFieldState';

import * as Const from '../constants';

const initState: MapFieldState = {
  isError: false,
  isLoading: false,
  mapFieldsById: {},
  userId: null,
  fieldId: null,
  currentSnapTile: null,
  currentDrawLayer: null,
};

export default function mapField (state: MapFieldState = initState, action): MapFieldState {
  switch (action.type) {

    case Const.FETCH_MAP_FIELD_INIT:
      return {
        ...initState,
        isLoading: false,
      };

    case Const.FETCH_MAP_FIELD_PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };

    case Const.FETCH_MAP_FIELD_SUCCESS:
      return {
        ...state,
        mapFieldsById: {
          ...state.mapFieldsById,
          [action.id]: {
            data: action.payload.data,
          },
        },
        isLoading: false,
        isError: false,
      };

    case Const.FETCH_MAP_FIELD_ERROR:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };

    case Const.FETCH_MAP_FIELD_USER_ID:
      return {
        ...state,
        userId: action.payload,
        isLoading: false,
        isError: false,
      };

    case Const.CURRENT_MAP_FIELD_ID:
      return {
        ...state,
        fieldId: action.payload,
      };

    case Const.SET_CURRENT_SNAP_TILE:
      return {
        ...state,
        currentSnapTile: action.snap,
      };

    default:
      return state;
  }
}
